import React from 'react'
import Button from '../components/Button'
import Tip from '../components/Tip'
import EmailForm from '../components/EmailForm'
//import HubspotForm from 'react-hubspot-form'
//import './hubspotform.js'

class SimplePage extends React.Component {
  constructor() {
    super()
    this.state = {
      selected: 0,
      hubspotSubmit: false,
    }
  }
  static defaultProps = {
    setWrapperState: () => {},
  }
  onNext() {
    var nextPage = this.props.data.nextPageIndex
    if (typeof nextPage === 'object') {
      nextPage = nextPage[this.state.selected - 1]
    }
    const toUpdate = this.props.data.propUpdated
      ? this.props.data.propUpdated
      : 'temp'
    this.setState({ selected: 0 })
    this.props.setWrapperState({
      currPage: nextPage,
      [toUpdate]: this.state.selected,
    })
  }

  onBack() {
    const { prevPageIndex, prevPageDecider } = this.props.data
    this.setState({ selected: 0 })
    if (typeof prevPageIndex === 'number') {
      this.props.setWrapperState({
        currPage: prevPageIndex,
      })
    } else {
      const prevPagePos = this.props.wrapperState[prevPageDecider]
      this.props.setWrapperState({
        currPage: prevPageIndex[prevPagePos - 1],
      })
    }
  }

  enabledNext(data) {
    const { selected, hubspotSubmit } = this.state
    if (!data.showHubSpot || selected === 2) {
      return selected !== 0
    }
    return hubspotSubmit
  }

  successSubmit(message) {
    alert(message)
    this.setState({ hubspotSubmit: true })
  }

  //Heres the hubspot code, in case we ever revert to it
  //  <HubspotForm
  //   portalId={data.hubsportPortalID}
  //   formId={data.hubsportFormID}
  //   onSubmit={() => this.setState({hubspotSubmit: true})}
  //   onReady={(form) => {}}
  //   loading={<div>Loading...</div>}
  // />

  render() {
    const { selected } = this.state
    const { data } = this.props
    var tipContent = data.tipContent
    var references = data.references;
    return (
      <div>
        <h1>{data.header}</h1>
        {data.options.map((op, index) => {
          var text
          if (typeof op === 'string') {
            text = op
          } else {
            if (this.props.wrapperState.gender === 2) {
              text = op.buttonText.male
            }
            else{
              text = op.buttonText.female
            }

            if (this.state.selected > 0 && index === this.state.selected - 1) {
              if (typeof op.tip === 'string') {
                tipContent = op.tip
              } else {
                if (this.props.wrapperState.gender === 2) {
                  tipContent = op.tip.male
                  references = op.tip.maleReferences
                } else {
                  tipContent = op.tip.female
                  references = op.tip.femaleReferences
                }
              }
            }
          }
          const variant = selected === index + 1 ? 'blue' : 'grey'
          return (
            <Button
              key={index}
              variant={variant}
              onClick={() => this.setState({ selected: index + 1 })}
            >
              {text}
            </Button>
          )
        })}
        {data.showHubSpot && selected === 1 && (
          <div className="hubspotForm">
            <EmailForm
              data={this.props.data}
              onSubmitSuccess={() => this.successSubmit(data.success)}
              wrapperState={this.props.wrapperState}
              summaryContent={this.props.summaryContent}
            />
          </div>
        )}
        {!(data.hideTipOnNo && selected === 2) && !data.tipDisabled && (
          <Tip marginTop="100px" title={data.tipHeader} references={references}>
            {tipContent}
          </Tip>
        )}
        <div className="footer">
          <div className="bottomButtons">
            <div>
              {!!data.prevButton && (
                <Button shape="round" onClick={() => this.onBack()}>
                  {data.prevButton}
                </Button>
              )}
            </div>
            <Button
              shape="round"
              variant="blue"
              onClick={() => this.onNext()}
              disabled={!this.enabledNext(data)}
            >
              {data.nextButton}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default SimplePage
